// Design tokens for the multi-stage UI. Where the master design system and the
// prototypes' colors_and_type.css disagree, the master file wins and these
// values follow it — see the status colors and fontDisplay below.
// Component styling lives in multiStage.scss; this remains the shared source of
// truth for the few colors still referenced from inline styles (TS/JS).
export const tokens = {
  navy: '#102942',
  navyProduct: '#0D2035',
  icy: '#C2D9F1',
  terracotta: '#E28654',
  purple: '#553271',
  cream: '#FCFCEB',
  gray700: '#374151',
  gray500: '#6B7280',
  gray200: '#E5E7EB',
  white: '#FFFFFF',
  // Status colors per the master design system. The blue matches this app's
  // existing $primary_color.
  success: '#2E7D32',
  // Not --color-success-bg (#E8F5E9). The journey pills are measured at #DFF2E0 in
  // the design and that was chosen over snapping them to the nearest token, so this
  // deliberately differs from the design system's generic success background.
  successBg: '#DFF2E0',
  danger: '#B74A3B',
  dangerBg: '#FBE8E4',
  info: 'var(--primary-color)',
  infoBg: '#CEE0F7',
  infoBorder: '#BFD8F0',
  upcomingBg: '#F0F2F5',
  warning: '#C08323',
  warningBg: '#FBEFD6',
  radiusSm: 8,
  radiusMd: 12,
  radiusLg: 16,
  radiusPill: 999,
  fontDisplay: "'Poppins', system-ui, sans-serif",
  fontBody: "'Poppins', system-ui, sans-serif",
} as const;
